module.exports = __webpack_public_path__ + "static/media/gp2.97ca471a.png";